import { useQuery } from '@tanstack/react-query';
import {
  membershipService,
  MembershipResponse,
  MembershipUsageResponse,
} from '@/services/membership.service';
import { defaultQueryOptions } from '@/config/react-query.config';

export const membershipKeys = {
  all: ['membership'] as const,
  detail: () => [...membershipKeys.all, 'detail'] as const,
  usage: () => [...membershipKeys.all, 'usage'] as const,
};

/**
 * Hook to fetch current user's membership
 */
export const useMembership = () => {
  return useQuery<MembershipResponse, Error>({
    queryKey: membershipKeys.detail(),
    queryFn: () => membershipService.getMembership(),
    ...defaultQueryOptions,
  });
};

/**
 * Hook to fetch the member's plan usage — free/paid booking
 * allowances at secondary locations, and the booked / cancelled /
 * no-show counts.
 *
 * Separate from `useMembership` because it is a separate endpoint
 * (`GET /memberships/usage`) with a different cache lifetime: the
 * plan itself changes at renewal, the counters change every time
 * the member books.
 */
export const useMembershipUsage = () => {
  return useQuery<MembershipUsageResponse, Error>({
    queryKey: membershipKeys.usage(),
    queryFn: () => membershipService.getUsage(),
    ...defaultQueryOptions,
  });
};

export default useMembership;
